// import { format,  } from 'date-fns'
import { formatWithOptions } from 'date-fns/fp'
import { ptBR } from 'date-fns/locale'


export default function formatDateHour(date: any) {
   const formatInputDate = formatWithOptions({ locale: ptBR }, 'd MMM yyyy hh:mm a')
   return formatInputDate(new Date(date))

}